import { useMemo } from 'react';
import { findNearestRouteComponent, useFindNearestRouteComponent } from './useFindNearestRouteComponent';
export function getRouteLocalCacheKey(component, props, prefix = 'app.filters') {
    // use route id instead of path since the path
    // can be configured and changed at any time
    const route = findNearestRouteComponent(component);
    const allProps = Object.assign({ routeId: (route === null || route === void 0 ? void 0 : route.id) || '' }, props);
    // sort object properties to avoid different order
    const path = Object.entries(allProps)
        .sort(([aKey], [bKey]) => (aKey > bKey ? -1 : aKey < bKey ? 1 : 0))
        .map(([key, value]) => `${key}[${value || ''}]`)
        .join('.');
    return `${prefix}.${path}`;
}
/**
 * Create (unique) local cache key based on the nearest
 * Route ancestor component ID and other properties.
 */
export function useRouteLocalCacheKey(component, props, prefix = 'app.filters') {
    const route = useFindNearestRouteComponent(component);
    return useMemo(() => {
        return getRouteLocalCacheKey(route, props, prefix);
    }, [prefix, props, route]);
}
//# sourceMappingURL=useRouteLocalCacheKey.js.map